const root = {
  state: {
    activeTour: 0,
    showBannerCount: null,
    isInrTransactionCompleted: false,
    fileDownloadNotification: false
  },
  getters: {
    getActiveTour: (state) => state.activeTour
  },
  mutations: {
    SET_TOUR_STATE: (state, data) => {
      state.activeTour = data ? state.activeTour + 1 : state.activeTour - 1
    },
    RESET_TOUR_STATE: (state) => {
      state.activeTour = 0
    },
    SET_BANNER_COUNT_CONFIG: (state, data) => {
      state.showBannerCount = data.showBannerCount
    },
    SET_TOTAL_TRANSACTIONS_CONFIG: (state, data) => {
      state.isInrTransactionCompleted = data.isInrTransactionCompleted
    },
    SET_DOWNLOAD_NOTIFICATION: (state, data) => {
      state.fileDownloadNotification = data.fileDownloadNotification
    }
  },
  actions: {
    setTourState({ commit }, data) {
      commit('SET_TOUR_STATE', data)
    },
    resetTourState({ commit }) {
      commit('RESET_TOUR_STATE')
    },
    setBannerCountConfig({ commit }, data) {
      commit('SET_BANNER_COUNT_CONFIG', data)
    },
    setTotalTransactionsConfig({ commit }, data) {
      commit('SET_TOTAL_TRANSACTIONS_CONFIG', data)
    },
    setDownloadNotification({ commit }, data) {
      commit('SET_DOWNLOAD_NOTIFICATION', data)
    }
  }
}

export default root
